import { useEffect, useState } from 'react';
import { useController, useFormContext } from 'react-hook-form';

import { dateToApiFormat } from '@epi-helpers/dateHelper';
import { FormFields } from '@epi-forms/helpers';
import { disableSaveButtonForBeneficiariesDataModal } from '@epi-helpers/BeneficiaryHelper';
import { useGetMetadataQuery } from '@epi-api/companyMetadata';

export const useTerminationDateDialog = (handleClose: () => void) => {
  const { control } = useFormContext();
  const [date, setDate] = useState<null | Date>(null);
  const { data: companyMetadata } = useGetMetadataQuery(undefined, {
    refetchOnMountOrArgChange: false
  });

  const endOfFundsPeriod = companyMetadata?.endOfFundsPeriod;

  const {
    field: { onChange: setEoF }
  } = useController({
    name: FormFields.EndOfFunds,
    control
  });

  const {
    field: { value: endOfBenefit, onChange }
  } = useController({
    name: FormFields.EndOfBenefit,
    control
  });

  const handleSave = () => {
    if (date === null) {
      onChange('');
      setEoF('');
      handleClose();
      return;
    }

    onChange(dateToApiFormat(date));
    if (endOfFundsPeriod && date) {
      const endOfFounds = new Date(date);
      const newDate = endOfFounds.setDate(
        endOfFounds.getDate() + endOfFundsPeriod
      );

      setEoF(dateToApiFormat(newDate));
    }
    handleClose();
  };

  const handleSetDate = (value: Date | null) => setDate(value);

  useEffect(() => {
    if (endOfBenefit) {
      setDate(new Date(endOfBenefit));
    }
  }, []);

  return {
    handleSetDate,
    handleSave,
    endOfBenefit,
    disableSave: disableSaveButtonForBeneficiariesDataModal(date)
  };
};
